var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"card card-body p-0",staticStyle:{"border-radius":"10px"}},[_c('module_table',{attrs:{"brochures":_vm.brochures,"totalPages":_vm.totalPages,"page":_vm.page,"setSkeletonLoader":_vm.displayLoader},on:{"setPage":_vm.setPage,"setSearch":_vm.setSearch}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }